import { ICellRendererParams } from 'ag-grid-community'

import { formatTimestamp } from '@/lib/date/date'

import type { ArtifactRow } from '@/pages/company-drawer/artifact/ag-grid-artifact/types'

export const ArtifactDateAddedCell = ({ data }: ICellRendererParams<ArtifactRow>) => {
  if (!data) return null

  const { dateAdded, dateUpdated } = data
  const displayDate = dateAdded ?? dateUpdated

  if (!displayDate) return <span className='text-main-foreground-tertiary'>–</span>

  return (
    <span className='text-nowrap text-md font-light text-main-foreground-primary'>
      {formatTimestamp(displayDate)}
    </span>
  )
}
